import React, { useEffect } from 'react';
import { Box, AppBar, Toolbar, Typography, Grid, Container, Link, LinearProgress, useTheme, useMediaQuery } from '@mui/material';
// import pwcLogo from "assets/newLogo.svg"
import pwc from "assets/images/pwc.svg"
import pwcLogo from "assets/images/pwc.svg";
import { useGetAllCompanyQuery } from 'store/slices/apis/apiSlice';
import { DEFAULT_THEME_COLOR } from 'config';

const SplashScreen = () => {
    const isMobile = useMediaQuery('(max-width:768px)');
    const { data, isLoading, isSuccess, isError, error } = useGetAllCompanyQuery();

    if (isSuccess && data?.data?.length > 0) {
        // console.log(data?.data?.[0]);

        if (data?.data?.[0]?.theme_color != null && data?.data?.[0]?.theme_color != undefined) {
            localStorage?.setItem('theme_color', data?.data?.[0]?.theme_color);
        } else {
            localStorage?.setItem('theme_color', DEFAULT_THEME_COLOR);
        }
        window.location.href = '/login';
    }

    if (isSuccess && data?.data?.length == 0) {
        localStorage?.setItem('theme_color', DEFAULT_THEME_COLOR);
        window.location.href = '/set-up-workspace';
    }

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            {/* Top App Bar */}
            <AppBar position="static" sx={{ backgroundColor: '#fff', boxShadow: 'none' }}>
                <Toolbar>
                    <img src={pwcLogo} style={{ width: isMobile ? '10%' : '3%' }} />
                </Toolbar>
            </AppBar>
            {isLoading &&
                <LinearProgress
                    sx={(theme) => ({
                        backgroundColor: '#fff',
                        '& .MuiLinearProgress-bar1': {
                            backgroundColor: '#C05222', // Theme-aware access
                        },
                        '& .MuiLinearProgress-bar2': {
                            backgroundColor: '#C05222', // Theme-aware access
                        }
                    })}
                />
            }

            {/* Main Content with Gradient Background */}
            <Box
                sx={{
                    flexGrow: 2,
                    display: 'flex',
                    alignItems: 'center',
                    flexDirection: 'column', // Align children vertically
                    justifyContent: 'center',
                    backgroundColor: '#f3f3f3',
                }}
            >
                <Typography
                    variant="h5"
                    align="center"
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        color: '#252525',
                        gap: '10px', // Adds space between the image and text
                        whiteSpace: 'nowrap',
                        fontSize: '16px'
                    }}
                >
                    <img src={pwcLogo} alt="PwC Logo" style={{ objectFit: 'contain' }} />
                    {/* PMIS Tool */}
                </Typography>
                {isLoading &&
                    <Typography variant="subtitle1" sx={{ color: '#696969', fontSize: '14px' }}>
                        loading....
                    </Typography>
                }

                {isError &&
                    <Typography variant="subtitle1" sx={{ color: '#696969', fontSize: '14px' }}>
                        Error
                    </Typography>
                }
            </Box>

            {/* Footer */}
            <Box sx={{ py: 2, backgroundColor: '#f5f5f5', textAlign: 'center' }}>
                <Container>
                    <Typography variant="caption" sx={{ color: '#252525', fontSize: '14px' }}>
                        <span style={{ opacity: 0.5 }}>Version: V1.2025 <br />
                        © 2025 PwC. All rights reserved. PwC refers to india member firm and may sometimes refer to the PwC network. Each member firm is a separate legal entity. Please see </span><Link target="_blank" href="https://www.pwc.com/structure" sx={{ color: '#000' }}>www.pwc.com/structure</Link> <span style={{ opacity: 0.5 }}>for further details.</span>
                    </Typography>
                    <Box sx={{ mt: 1 }}>
                        <Link href="#" color="inherit" sx={{ mx: 1, fontSize: '14px', letterSpacing: '24px', fontWeight: '400', letterSpacing: '-0.2px' }}>
                            Legal Disclaimers
                        </Link>
                        |
                        <Link href="#" color="inherit" sx={{ mx: 1, fontSize: '14px', letterSpacing: '24px', fontWeight: '400', letterSpacing: '-0.2px' }}>
                            Contact Support
                        </Link>
                        |
                        <Link href="#" color="inherit" sx={{ mx: 1, fontSize: '14px', letterSpacing: '24px', fontWeight: '400', letterSpacing: '-0.2px' }}>
                            Click me!
                        </Link>
                    </Box>
                </Container>
            </Box>
        </Box>
    );
};

export default SplashScreen;
